import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UserData } from '../../Models/Authentication/UserModel';
import { User } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-linktree-top',
  templateUrl: './linktree-top.component.html',
  styleUrls: ['./linktree-top.component.css'],
  standalone:false
})
export class LinktreeTopComponent extends BaseComponent  implements OnInit {
  @Input() username:string=''
  name:string="https://touchconnectapp.web.app/"
  user!:User
  user1!:UserData
  userId:string;
  form!: FormGroup;
  Links!: FormGroup;
  MailForm!: FormGroup;
  //imageUrl: string = '../../../assets/images/Linktree/templates/DumyUser.png';
  loading:boolean=false;

  loadImg:boolean=false;
  constructor(
    private messageService: MessageService,
    private api: BaseApiService,
    private auth:AuthService

  ){
     super()
     this.userId=this.auth.getUID();
  }

  GetAll(uid:any){
    this.loading=true;
    this.api.read(`Auth/getByIdDT?uid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.user1    = response;
          this.username = this.user1.userName
          this.loading  = false;
        },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    
    )
   }

 ngOnInit(): void {
  if(this.userId!=null)
  {
    this.GetAll(this.userId)
  }

 }

}
